import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Actions} from '../../../common/actions';
import {Modal, Button, Dropdown} from 'semantic-ui-react';
import {warehouses} from '../../../common/dictionaries/parameters';
import {invoicesTypes} from '../../../common/dictionaries/classification';
import './confirmation.scss';

class ConfirmationModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'modalWasOpen': false,
      'invoiceTypeSelected': '',
      'transportSelected': '',
    };

    this.onCloseModalClick = this.onCloseModalClick.bind(this);
    this.onInvoiceClick = this.onInvoiceClick.bind(this);
    this.updateTransportSelected = this.updateTransportSelected.bind(this);
    this.updateInvoiceTypeSelected = this.updateInvoiceTypeSelected.bind(this);
  }

  fetchData() {
    const {agency} = this.props;
    this.setState({
      'modalWasOpen': true,
      'invoiceTypeSelected': invoicesTypes[0].value,
      'transportSelected': '',
    });

    this.props.fetchTransports(agency.dealerIdentification, agency.code);
  }

  getInvoicesTypes() {
    return invoicesTypes.map((item) => {
      return {'text': item.name, 'value': item.value};
    });
  }

  updateInvoiceTypeSelected(event, {value}) {
    this.setState({'invoiceTypeSelected': value});
  }

  getTransports() {
    return this.props.listTransports.map((item) => {
      return {'text': item.driverName, 'value': item.driverRuc};
    });
  }

  updateTransportSelected(event, {value}) {
    this.setState({'transportSelected': value});
  }

  onCloseModalClick() {
    this.setState({'modalWasOpen': false});
  }
  
  onInvoiceClick() {
    const {agency, sequencesMarked} = this.props;
    const {invoiceTypeSelected, transportSelected} = this.state;

    const data = {
      'warehouse': warehouses.lubricants,
      'invoiceType': invoiceTypeSelected,
      'driver': transportSelected,
      'sequences': sequencesMarked,
    };

    this.props.createLubricantsInvoice(agency, data);
    this.onCloseModalClick();
  }

  render() {
    const {loadingTransports, processingInvoice} = this.props;
    const {modalWasOpen, invoiceTypeSelected, transportSelected} = this.state;
    
    return (
      <Modal size='tiny' onOpen={() => this.fetchData()}
        className='lubricants-invoicing-confirmation'
        open={modalWasOpen}
        trigger={
          <Button
            type='button'
            primary
            className='toyota-primary'
            disabled={processingInvoice}
          >
            Facturar
          </Button>
        }>

        <Modal.Header>
          Confirmación
        </Modal.Header>
        
        <Modal.Content>
          <Modal.Description>
            <p className='message'>Por favor seleccione estos campos obligatorios para proceder</p>
            <div>
              <h4>Tipo Factura</h4>
              <Dropdown selection
                options={this.getInvoicesTypes()}
                searchInput={{'autoFocus': true}}
                value={invoiceTypeSelected}
                onChange={this.updateInvoiceTypeSelected}
                placeholder='Seleccione tipo de factura'
              />
            </div>
            <div>
              <h4>Transportista</h4>
              <Dropdown selection
                options={this.getTransports()}
                search
                value={transportSelected}
                disabled={loadingTransports}
                loading={loadingTransports}
                onChange={this.updateTransportSelected}
                placeholder='Seleccione un transportista'
                noResultsMessage='Transportista no encontrado'
              />
            </div>
          </Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={this.onCloseModalClick}>
            Cancelar
          </Button>
          <Button positive
            disabled={!invoiceTypeSelected || !transportSelected}
            onClick={this.onInvoiceClick}>
            Facturar
          </Button>
        </Modal.Actions>

      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingTransports': state.transport.loading,
    'listTransports': state.transport.list,
    'sequencesMarked': state.lubricantsInvoicing.sequencesMarked,
    'processingInvoice': state.lubricantsInvoicing.creatingInvoice,
  };
};

const {
  fetchTransports,
  createLubricantsInvoice,
} = Actions;

export default connect(mapStateToProps, {
  fetchTransports,
  createLubricantsInvoice,
})(ConfirmationModal);
